export default {
  sidebarLock: (state) => state.sidebarLock,
  scrollLocked: (state) => state.scrollLocked,
  modeDebug: (state) => state.modeDebug,
  dashboard: (state) => state.dashboard,
  colDatatables: (state) => (key, colsDefault = []) =>
    state.colDatatables[key] || colsDefault
}
